import { HackathonStage, StageTypeEnum } from '@/models/Hackathon';
import moment from 'moment';
import {
  getCurrentStage,
  getLastCompletedStage,
  getStageByType,
} from '../hackathon';
import Permission from './Permission';

export default class HackathonStagesPermission extends Permission<
  HackathonStage[]
> {
  canManage(): boolean {
    return this.hasSuperPrivileges();
  }

  canManageSemifinal(): boolean {
    if (!this.model) return false;
    const semifinal = getStageByType(this.model, StageTypeEnum.INITIAL_VOTING);
    const semifinalStart = moment(semifinal?.startDate);
    const semifinalEndMore14days = moment(semifinal?.endDate).add(14, 'days');
    const inInterval = moment().isBetween(
      semifinalStart,
      semifinalEndMore14days,
      undefined,
      '[]',
    );

    return inInterval && this.hasSuperPrivileges();
  }

  canManageFinal(): boolean {
    if (!this.model) return false;
    const final = getStageByType(this.model, StageTypeEnum.FINAL_VOTING);
    const finalStart = moment(final?.startDate);
    const finalEndMore14days = moment(final?.endDate).add(14, 'days');
    const inInterval = moment().isBetween(
      finalStart,
      finalEndMore14days,
      undefined,
      '[]',
    );

    return inInterval && this.hasSuperPrivileges();
  }

  canShowFinalLivestream() {
    if (!this.model) return false;
    const lastCompletedStage = getLastCompletedStage(this.model);
    const currentStage = getCurrentStage(this.model);

    const lastCompletedStageIsInitialVoting =
      lastCompletedStage?.type === StageTypeEnum.INITIAL_VOTING;

    const currentStageIsFinalVoting =
      currentStage?.type === StageTypeEnum.FINAL_VOTING;

    return currentStageIsFinalVoting || lastCompletedStageIsInitialVoting;
  }

  canShowRecordLivestream() {
    if (!this.model) return false;
    const lastCompletedStage = getLastCompletedStage(this.model);

    const lastCompletedStageIsFinal =
      lastCompletedStage?.type === StageTypeEnum.FINAL_VOTING;

    return lastCompletedStageIsFinal;
  }
}
